import { Input } from '@orobix/orobix-fe-components'
import { useField, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

export interface DatasetNameProps {
  fieldName: string
  placeholder?: string
  disabled?: boolean
}

type E = React.ChangeEvent<HTMLInputElement>

const DatasetName = ({
  fieldName,
  placeholder,
  disabled,
}: DatasetNameProps) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()
  const [field, meta, helpers] = useField(fieldName)

  const { name, value } = field
  const { error, touched } = meta
  const { setValue, setTouched } = helpers

  return (
    <Input
      name={name}
      id={name}
      label={t('Name')}
      type="text"
      value={value}
      onChange={(e: E) => setValue(e.target.value)}
      onBlur={() => setTouched(true)}
      disabled={disabled || isSubmitting}
      error={!!(error && touched)}
      errorMessage={error}
      maxLength={50}
      placeholder={placeholder}
    />
  )
}

export default DatasetName
